import React from 'react';
import './StyleComponents/HomeIntroduction.css';

const HomeIntroduction = () => {
    return (
        <div className="IntroWrapper" id='who'>

            {/* LEFT CARD */}
            <div className="GlassCard">
                <div className="acronymSide">
                    <p><span className="letter">Z</span> — Zealous light that brightens every room</p>
                    <p><span className="letter">A</span> — Angelic soul with effortless grace</p>
                    <p><span className="letter">R</span> — Rarest smile and laugh</p>
                    <p><span className="letter">A</span> — Adorably bubbly in the most beautiful way</p>
                </div>
            </div>

            {/* RIGHT CARD */}
            <div className="GlassCard">
                <div className="descriptionSide">
                    <h3>Who is she 🤍</h3>

                    <p>
                        She is the most beautiful being the universe has ever created.
                        A soul so gentle it brings calm without trying,
                        an artistic mind that sees wonder where others see ordinary,
                        and a presence so rare it quietly turns moments into memories.
                    </p>

                    <p>
                        Her smile has a way of staying with you,
                        her laughter feels like light,
                        and her energy is impossible to miss: warm, comforting, and dangerously addictive.
                    </p>
                </div>
            </div>

        </div>
    );
};

export default HomeIntroduction;
